import { UserWorkoutSession } from 'fitbeat.gym-core';
import { UserProfile } from 'fitbeat.models';
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import {
  StyleSheet, Text, View,
} from 'react-native';
import { connect } from 'react-redux';
import { Button, Icon } from '../../components';
import { IAppStore } from '../../HomeWorkouts';
import Theme, { ThemeType } from '../../theme';
import { defaultScale } from '../../utils/scaling';
import {
  saveBagContactSettingsAndCheckIn,
} from '../actions';
import { BookingFlowFooter } from '../components';
import { AllowBagContactSelection } from '../components/AllowBagContactSelection';
import { BookingInstructionHeader, BookingInstructionSubtitle } from '../components/BookingInstructions';
import { styles as sharedStyles } from './Styles';

export interface IProps {
  userProfile: UserProfile;
  workoutSession: UserWorkoutSession;
  checkInError: string | null;
  updatingBoxingSetting: boolean;
  t(key: string, options?: any): string;
  saveBagContactSettingsAndCheckIn(userProfile: UserProfile, allowBagContact: boolean): void;
}

interface IState {
  bagContactEnabled: boolean;
}

class BagContactStep extends Component<IProps, IState> {
  constructor(props) {
    super(props);
    this.state = {
      bagContactEnabled: props.workoutSession.settings?.allowBagContact || false,
    };
  }

  public done = () => {
    this.props.saveBagContactSettingsAndCheckIn(this.props.userProfile, this.state.bagContactEnabled);
  };

  public render() {
    const { checkInError } = this.props;
    if (checkInError) {
      return this.renderError();
    }
    return this.renderSuccess();
  }

  public changeBagContactSetting = (setting) => {
    this.setState({ bagContactEnabled: setting });
  };

  public renderSuccess = () => {
    const { t, updatingBoxingSetting } = this.props;
    const { bagContactEnabled } = this.state;
    return (
      <View style={sharedStyles.container}>
        <View style={{ flex: 1, justifyContent: 'center' }}>
          <BookingInstructionHeader
            style={styles.selectionHeading}
            header={t('selectBagContactSelection')}
          />
          <AllowBagContactSelection
            t={t}
            theme={ThemeType.light}
            allowBagContactSetting={bagContactEnabled}
            onPress={async (setting) => this.changeBagContactSetting(setting)}
          />
          <BookingInstructionSubtitle
            style={{ color: Theme.GREY_DARK_MEDIUM }}
            header={bagContactEnabled ? t('bagContactDescription') : t('noBagContactDescription')}
          />
        </View>
        <BookingFlowFooter>
          <Button
            fontColor={Theme.WHITE}
            title={t('accept')}
            onPress={this.done}
            isLoading={updatingBoxingSetting}
          />
        </BookingFlowFooter>
      </View>
    );
  };

  public renderError = () => {
    const { checkInError, t } = this.props;
    return (
      <View style={sharedStyles.container}>
        <View style={styles.container}>
          <Icon
            size={defaultScale(80)}
            name='ios-alert-outline'
            color={Theme.PRIMARY}
          />
          <Text style={styles.title}>{t('checkInErrorHeading')}</Text>
          <Text style={styles.subheading}>
            {checkInError}
          </Text>
        </View>
        <BookingFlowFooter>
          <Button
            fontColor={Theme.WHITE}
            title={t('Done')}
            onPress={this.done}
          />
        </BookingFlowFooter>
      </View>
    );
  };
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    ...Theme.textStyle.display1Bold,
  },
  subheading: {
    ...Theme.textStyle.headingReg,
    textAlign: 'center',
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
  },
  selectionHeading: {
    ...Theme.textStyle.heading,
    color: Theme.BLACK,
  },
});
const mapStateToProps = (state: IAppStore) => ({
  workoutSession: state.bookings.bookingWizard.workoutSession,
  checkInLoading: state.bookings.bookingWizard.checkInLoading,
  checkInError: state.bookings.bookingWizard.checkInError,
  updatingBoxingSetting: state.bookings.bookingWizard.updatingBoxingSetting,
});

const mapDispatchToProps = (dispatch) => ({
  saveBagContactSettingsAndCheckIn: (
    userProfile: UserProfile,
    workoutSession: UserWorkoutSession,
  ) => dispatch(saveBagContactSettingsAndCheckIn(userProfile, workoutSession)),
});

export default translate(['bookings'], { wait: true })(
  connect(mapStateToProps, mapDispatchToProps)(BagContactStep),
);
